import { render, staticRenderFns } from "./ChipTagSelect.vue?vue&type=template&id=17588ac4&scoped=true&"
import script from "./ChipTagSelect.vue?vue&type=script&lang=ts&"
export * from "./ChipTagSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ChipTagSelect.vue?vue&type=style&index=0&id=17588ac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17588ac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17588ac4')) {
      api.createRecord('17588ac4', component.options)
    } else {
      api.reload('17588ac4', component.options)
    }
    module.hot.accept("./ChipTagSelect.vue?vue&type=template&id=17588ac4&scoped=true&", function () {
      api.rerender('17588ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tags/ChipTagSelect.vue"
export default component.exports